export interface DataSet {
  id: string;
  name: string;
  description: string;
  acronym: string;
  active?: boolean;
}
